import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { spacing } from "../../design-system/tokens/spacing";
import { TriggerButton, ChevronIcon, Content, Item } from "./ShareMenu.styles";

// Numeric spacing constants derived from token strings — used for Radix
// numeric props (sideOffset, collisionPadding).
const SIDE_OFFSET = parseInt(spacing[2], 10); // 8px
const COLLISION_PADDING = parseInt(spacing[2], 10); // 8px

export interface ShareMenuProps {
  /** Controls whether the dropdown is open. */
  open: boolean;
  /** Called when the open state should change. */
  onOpenChange: (open: boolean) => void;
  /** Called when the user selects "Collaborate". */
  onCollaborate?: () => void;
  /** Called when the user selects "Deliver story". */
  onDeliverStory?: () => void;
  /** Called when the user selects "Export". */
  onExport?: () => void;
  /** Shows Export as unavailable ("Coming soon") and ignores clicks. */
  exportDisabled?: boolean;
  /** Disables the trigger button and prevents the menu from opening. */
  disabled?: boolean;
}

const ShareMenu: React.FC<ShareMenuProps> = ({
  open,
  onOpenChange,
  onCollaborate,
  onDeliverStory,
  onExport,
  exportDisabled = false,
  disabled = false,
}) => {
  return (
    <DropdownMenu.Root open={open} onOpenChange={onOpenChange}>
      <DropdownMenu.Trigger asChild>
        <TriggerButton disabled={disabled} aria-label="Share options">
          Share
          <ChevronIcon $open={open} aria-hidden />
        </TriggerButton>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <Content
          sideOffset={SIDE_OFFSET}
          align="end"
          collisionPadding={COLLISION_PADDING}
        >
          <Item onSelect={onCollaborate}>Collaborate</Item>
          <Item onSelect={onDeliverStory}>Deliver story</Item>
          <Item onSelect={onExport} disabled={exportDisabled} title={exportDisabled ? "Coming soon" : undefined}>
            {exportDisabled ? "Export (Coming soon)" : "Export"}
          </Item>
        </Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default ShareMenu;
